// extracted by mini-css-extract-plugin
export default {"container":"std-dashboard_container__PGqZN"};